import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_g4k2kqs2t6: FaireBrandEntity = {
  token: "b_g4k2kqs2t6",
  type: "brand",
  name: "570 Soap Company",
  avatarUrl:
    "https://cdn.faire.com/fastly/33d5612a9e46b5621220b3d1d80f75ab3bd448c3fe5dc5398ddefe4a47b65e92.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f63805873834d67d594b7bdf771057d00d34cd0d1be4691c910b8cb8a5beb790.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/33d5612a9e46b5621220b3d1d80f75ab3bd448c3fe5dc5398ddefe4a47b65e92.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f63805873834d67d594b7bdf771057d00d34cd0d1be4691c910b8cb8a5beb790.jpeg",
  location: "Orangeville, PA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 26,
  isTopShop: true,
  isInsider: true,
  description:
    "Our Story\n570 Soap Co. began with a personal mission—born from the love of a parent and the desire to help my children feel comfortable in their own skin. As a mother, I faced challenges watching my child struggle with skin issues. Determined to make a change, I began creating gentle, clean, and effective skincare products right at home.\n\nWhat started as a way to help my kids evolved into a passion project when my daughter’s dance team needed a unique fundraising idea. I began making cold process soaps and other bath and body products, sharing my creations at local events. The positive feedback and community support propelled 570 Soap Co. into the vibrant business it is today.\n\nWhat Sets Us Apart\nAt 570 Soap Co., every product is a labor of love. I personally craft each item—from cold process soaps and bath bombs to lotions, scrubs, and more—using simple ingredients and “clean scents” that avoid known toxins. My focus is on creating high-quality, affordable products that cater to everyday skin needs while honoring our commitment to a natural approach.\n\nRooted in Community\nNamed after the 570 area code, our brand is deeply connected to where it all began. Being based in Orangeville, PA, our story is woven into the fabric of our local community. Whether you find us online, at local festivals, or soon in our renovated storefront, you’ll always find a genuine connection and a personal touch in everything we do.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:56.657Z",
    importedBy: "entity-db-cli",
  },
};
